var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.831 2.492a3.333 3.333 0 0 0-3.333 3.334v8.333a3.333 3.333 0 0 0 3.333 3.333h8.334a3.333 3.333 0 0 0 3.333-3.333V5.826a3.333 3.333 0 0 0-3.333-3.334zm0 1.667h8.334c.92 0 1.666.746 1.666 1.667v8.333c0 .92-.745 1.667-1.666 1.667H5.83c-.92 0-1.666-.747-1.666-1.667V5.826c0-.92.746-1.667 1.666-1.667m.834 1.667a.833.833 0 0 0 0 1.666h6.666a.833.833 0 0 0 0-1.666zm.833 3.333a.833.833 0 0 0 0 1.667h5a.834.834 0 0 0 0-1.667zm.833 3.333a.833.833 0 0 0 0 1.667h3.334a.833.833 0 0 0 0-1.667z"
  })));
};
export default SvgFilter;